module.exports = require('./helpers/bundle-url').getBundleURL('6blyj') + "PRSMlogo200.3b156bda.webp";